export default __webpack_public_path__ + "static/media/Francesco Piccolo.f8738f3a.jpg";